module.exports = __webpack_public_path__ + "media/images/manage-offer/information-5369659e4fdafa071b545f7610801df7.png";